import React, {useMemo} from "react";
import {filterSelectedCarDetails} from "@/utils/filesConstants.js";
import ModalHeader from "@/customComponents/uiComponents/modal/ModalHeader.jsx";
import {CouponForm, CouponFormInput, CouponFormSubmit} from "../Components/couponForm.jsx";

// Mobile step for the coupon box (desktop opens the same thing as a popup). It used to
// carry its OWN copy of the validate → store → recalculate logic, which is how it ended
// up without the clear (✕) and the unapply-on-edit behaviour the popup has. It now
// renders the shared CouponForm, so there is one implementation to keep correct.
export function ApplyCoupon({setStep, closeModal}) {
    const carDetails = useMemo(() => {
        try { return filterSelectedCarDetails(); } catch { return null; }
    }, []);

    return (
        <>
            <ModalHeader
                title="Add A Coupon"
                extraClasses=""
                totalSteps={0}
                cancelButton={false}
                cancelButtonType="text"
                backStep="selectedCarDetails"
                showBackButton={true}
                enableEditModeOnBackButton={false}
                setStep={setStep}
                closeModal={closeModal}
            />
            <CouponForm carDetails={carDetails} setStep={setStep} previousStep="selectedCarDetails">
                <div className="modalPages-spacing pb-8">
                    {/* In-CONTENT heading, matching the plugin. The ModalHeader title above
                        is hidden on mobile (the 767 block hides .header-title), so without
                        this the sheet opens with no heading at all. */}
                    <h4 className="coupon-form-title">Add A Coupon</h4>
                    <CouponFormInput/>
                    <CouponFormSubmit/>
                </div>
            </CouponForm>
        </>
    );
}
export default ApplyCoupon;
